import type { HttpValidationError, PasswordPolicyPublic } from "@common/client"
import { AxiosError } from "axios"
import { getErrorMessage } from "./lib/error-utils"

export function countPasswordCharacterClasses(password: string): number {
  return (
    (/[a-z]/.test(password) ? 1 : 0) +
    (/[A-Z]/.test(password) ? 1 : 0) +
    (/[0-9]/.test(password) ? 1 : 0) +
    (/[^A-Za-z0-9\s]/.test(password) ? 1 : 0)
  )
}

// Re-export error utility for convenient access
export { getErrorMessage }

export const emailPattern = {
  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  message: "Invalid email address",
}

export const namePattern = {
  value: /^[A-Za-z\s\u00C0-\u017F]{1,30}$/,
  message: "Invalid name",
}

export const usernamePattern = {
  value: /^[a-z0-9_]+$/,
  message:
    "Username can only contain lowercase letters, numbers, and underscores",
}

export const passwordRules = (
  policy: PasswordPolicyPublic,
  isRequired = true,
) => {
  const rules: any = {
    minLength: {
      value: policy.min_length,
      message: `Password must be at least ${policy.min_length} characters`,
    },
    maxLength: {
      value: policy.max_length,
      message: `Password must be at most ${policy.max_length} characters`,
    },
    validate: (value: string) => {
      if (!value) {
        return isRequired ? "Password is required" : true
      }
      if (countPasswordCharacterClasses(value) < policy.min_character_classes) {
        return `Password must contain at least ${policy.min_character_classes} of: lowercase, uppercase, digit, symbol`
      }
      return true
    },
  }

  if (isRequired) {
    rules.required = "Password is required"
  }

  return rules
}

export const confirmPasswordRules = (
  getValues: () => any,
  isRequired = true,
) => {
  const rules: any = {
    validate: (value: string) => {
      const password = getValues().password || getValues().new_password
      return value === password ? true : "The passwords do not match"
    },
  }

  if (isRequired) {
    rules.required = "Password confirmation is required"
  }

  return rules
}

export const handleError = (
  err: HttpValidationError | AxiosError,
  showToast: any,
) => {
  if (err instanceof AxiosError) {
    const errorMessage = getErrorMessage(err)
    showToast("Error", errorMessage, "error")
  } else {
    showToast("Error", "Unknown error", "error")
  }
}
